import { defineStore } from "pinia";
import http from "@/axios-config";
import router from "@/router";

// main is the name of the store. It is unique across your application
// and will appear in devtools
export const useAuthStore = defineStore("auth", {
    // a function that returns a fresh state
    state: () => ({
        currentUser: null,
        isAuthenticated: window.auth,
    }),
    // optional actions
    actions: {
        async login(email, password) {
            const csrf = await http.get("/sanctum/csrf-cookie");

            try {
                const loginResponse = await http.post("/api/auth/login", {
                    email: email,
                    password: password,
                });

                if (loginResponse.status === 200) {
                    router.push({ path: "/" });
                    this.isAuthenticated = true;
                    this.getUser();
                    return;
                } else {
                    throw new Error(loginResponse);
                }
            } catch (err) {
                throw new Error(err.response.data.error);
            }
        },

        logout(email, password) {
            http.get("/sanctum/csrf-cookie").then((response) => {
                http.post("/api/auth/logout", {
                    email: email,
                })
                    .then((response) => {
                        router.push({ name: "login" });
                        this.isAuthenticated = false;
                        this.currentUser = null;
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            });
        },

        checkAuth() {
            http.get("/api/auth/check").then((response) => {
                this.isAuthenticated = response.data;

                if (this.isAuthenticated) this.getUser();
                else if (router.currentRoute.value.name != "reset-password") {
                    router.push({ name: "login" });
                }
            });
        },

        getUser() {
            http.get("/api/auth/user").then((response) => {
                this.currentUser = response.data;
            });
        },
    },
    // optional getters
    getters: {
        authenticated(state) {
            return state.isAuthenticated;
        },

        user(state) {
            return state.currentUser;
        },
    },
});
